module.exports = __webpack_public_path__ + "img/hz1.9f60a5ee.png";